import { getConversationsRequest, getConversationRequest, updateConversation, removeConversation, addConversationMessage, setMessageWritting, getMessageAuthorId } from './ConversationActions';
import { sendNotification } from '../Error/ErrorActions';

// Conversation
export default function socketListner(socket, dispatch, intl, getUser = () => null) {
    socket.on('conversation/new', () => {
        dispatch(getConversationsRequest());
    });

    socket.on('conversation/removed', data => {
        data.conversation && dispatch(removeConversation(data.conversation._id));
    });

    socket.on('conversation/updated', data => {
        data.conversation && dispatch(getConversationRequest(data.conversation._id, true));
    });

    socket.on('conversation/message/new', data => {
        console.log('conversation/message/new', data);
        if(data.message && !data.message.hideToRoles.includes((getUser() || {}).role)) {
            dispatch(addConversationMessage(data.message));
            data.message.author && data.message.type === 'user' && (getUser() || {})._id !== getMessageAuthorId(data.message) && sendNotification(`${data.message.author?.firstName ? `${data.message.author.firstName}: ` : ''}${data.message.text || data.message.file || ''}`);
        }
    });

    socket.on('conversation/message/writting', data => {
        data.user && data.conversation && data.user._id !== (getUser() || {})._id && dispatch(setMessageWritting(data.user, data.conversation, data.isWritting || false));
    });
}
